import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
    '& .login-back-button': {
      color: `${palette.background.brandLight} !important`,
    },
    '& .login-form-container button[type="submit"]': {
      backgroundColor: `${palette.background.brandLight} !important`,
      background: `${palette.background.brandLight} !important`,
      color: `${palette.text.highlight} !important`,
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: `${palette.background.brandLight} !important`,
        background: `${palette.background.brandLight} !important`,
        color: `${palette.text.highlight} !important`,
        filter: 'brightness(1.2)',
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .topbar-signup-cta': {
      backgroundColor: `${palette.text.brandAction} !important`,
      color: `${palette.text.highlight} !important`,
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: `${palette.text.brandAction} !important`,
        color: `${palette.text.highlight} !important`,
        filter: 'brightness(1.2)',
      },
    },
    '& .sidebar-drawer-signup-row .MuiButton-containedPrimary': {
      backgroundColor: `${palette.background.brandLight} !important`,
      color: `${palette.text.highlight} !important`,
      boxShadow: 'none !important',
    },
  },

  /* Checkout — Payment Details drawer (MFE CustomDrawer / DrawerComponent) */
  '.custom-drawer-wrapper .drawer-title-container': {
    background: `${palette.background.dark} !important`,
    color: `${palette.text.highlight} !important`,
    '& .drawer-title': {
      color: `${palette.text.highlight} !important`,
    },
    '& .drawer-close-button': {
      color: `${palette.text.highlight} !important`,
    },
  },
  '.custom-drawer-wrapper .checkout_stripe_payment': {
    '& .MuiButton-containedPrimary:not(.Mui-disabled), & .MuiButton-containedSecondary:not(.Mui-disabled)': {
      background: `${palette.background.brandLight} !important`,
      backgroundColor: `${palette.background.brandLight} !important`,
      color: `${palette.text.highlight} !important`,
      '&:hover': {
        background: `${palette.background.brandLight} !important`,
        backgroundColor: `${palette.background.brandLight} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },
  },

  '.group-parent-container': {
    /* Kill plan-card hover (MFE CSS + highlight-card JS); keep button :hover only */
    '& .planCard.MuiCard-root, & .planCard.MuiPaper-root, & .planCard': {
      transition: 'none !important',
      '&:hover, &.highlight-card, &:hover.highlight-card': {
        backgroundColor: `${palette.text.highlight} !important`,
        background: `${palette.text.highlight} !important`,
        color: `${palette.text.primary} !important`,
        transform: 'none !important',
        filter: 'none !important',
        outline: 'none !important',
      },
      '&.MuiPaper-elevation1:hover, &.MuiPaper-elevation1.highlight-card': {
        boxShadow: 'none !important',
      },
      '&:hover .customcardTitle, &.highlight-card .customcardTitle': {
        color: `${palette.text.brand} !important`,
      },
      /* Keep divider under Get Started visible when MFE adds highlight-divider */
      '& .cardDivider .MuiDivider-root, & .highlight-divider, &.highlight-card .cardDivider .MuiDivider-root':
        {
          backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
          background: 'rgba(0, 0, 0, 0.12) !important',
        },
      /* Neutralize JS card-hover button swap; only react to real button hover */
      '& .customGetStarted, & .plan-card-v5-get-started, & .customGetStarted.MuiButton-contained, & .customGetStarted.MuiButton-containedPrimary, & .plan-card-v5-get-started.MuiButton-contained':
        {
          backgroundColor: 'transparent !important',
          background: 'transparent !important',
          color: `${palette.background.brandLight} !important`,
          border: `1px solid ${palette.background.brandLight} !important`,
          boxShadow: 'none !important',
        },
      '& .customGetStarted:hover, & .plan-card-v5-get-started:hover, & .customGetStarted.MuiButton-contained:hover, & .customGetStarted.MuiButton-containedPrimary:hover, & .plan-card-v5-get-started.MuiButton-contained:hover, & .MuiButton-outlinedPrimary:hover':
        {
          backgroundColor: `${palette.background.brandLight} !important`,
          background: `${palette.background.brandLight} !important`,
          border: `1px solid ${palette.background.brandLight} !important`,
          borderColor: `${palette.background.brandLight} !important`,
          color: `${palette.text.highlight} !important`,
        },
    },
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.primary.main,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'Montserrat-Medium !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .savings-hero-section, & .checkout-hero-section, & .plan-selection-section, & .faq-hero-section, & .dashboard-hero-section, & .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      background: `${palette.text.brandAction}`,
      backgroundSize: 'cover',
      position: 'relative',
      /* Wavy bottom edge. The band clips its overflow, so this sits inside it and
         is drawn in the page colour below — the wavy top edge cuts into the band. */
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: '38px',
        backgroundImage: 'url("/images/home-images/wave-white.svg")',
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'center bottom',
        backgroundSize: '783px 38px',
        transform: 'scaleY(-1)',
        pointerEvents: 'none',
        zIndex: 2,
      },
      '& > section': {
        paddingBlock: '80px !important',
      },
      '& .section-header': {
        marginBottom: '32px !important',
      },
      '& .section-header__subtitle-wrapper': {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
      },
      '& .hero-header-title': {
        fontFamily: 'Montserrat-Medium !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-2.16px !important',
        fontWeight: '600 !important',
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Figtree-Regular !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        fontWeight: '400 !important',
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },

      /* Hero CTAs: one row on mobile — side-by-side pills (MFE Grid uses xs={6} + wrap can stack) */
      '& .header-container': {
        gap: '20px',
        margin: '0 !important',
        flexWrap: 'nowrap !important',
        flexDirection: 'row !important',
        justifyContent: 'center',
        alignItems: 'center',
        '& > .MuiGrid-item': {
          flexBasis: 'auto !important',
          maxWidth: 'none !important',
          width: 'auto !important',
          minWidth: 0,
          padding: '0 !important',
        },
      },
      '& .hero-link-button': {
        borderRadius: '9999px !important',
        minHeight: '48px',
        height: '48px',
        width: '144px !important',
        padding: '13px 20px !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        fontWeight: 400,
        fontFamily: 'Figtree-Regular, sans-serif !important',
        textTransform: 'none',
        letterSpacing: '-0.32px',
        maxWidth: '100%',
        backgroundColor: `${palette.background.main} !important`,
        color: `${palette.text.textPrimary} !important`,
        border: 'none !important',
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.background.light} !important`,
          color: `${palette.text.textPrimary} !important`,
        },
      },
      '& .hero-home-button': {
        borderRadius: '9999px !important',
        minHeight: '48px',
        height: '48px',
        width: '144px !important',
        padding: '13px 20px !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        fontWeight: 400,
        fontFamily: 'Figtree-Regular, sans-serif !important',
        textTransform: 'none',
        letterSpacing: '-0.32px',
        maxWidth: '100%',
        backgroundColor: 'transparent !important',
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.background.border} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.background.level1} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
      '@media (max-width: 600px)': {
        '& > section': {
          paddingBlock: '56px !important',
        },
        '& .hero-link-button, & .hero-home-button': {
          width: 'auto !important',
          padding: '13px 18px !important',
        },
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      backgroundColor: palette.background.brandLight,
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '-1px',
        height: '38px',
        backgroundImage: 'url("/images/home-images/wave-pricing-top.svg")',
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'center bottom',
        backgroundSize: '783px 38px',
        transform: 'scaleY(-1)',
        pointerEvents: 'none',
        zIndex: 3,
      },
      /* Tablet + laptop + desktop: column layout + height so cover image fills (MFE uses row from sm+) */
      '@media(min-width: 600px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        minHeight: 'clamp(480px, 70vh, 760px)',
      },
      '@media(max-width: 1200px) and (min-width: 900px)': {
        maxHeight: '600px !important',
        minHeight: '560px',
      },
      '@media(max-width: 600px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        backgroundColor: palette.background.heroMobile,
        paddingTop: '0 !important',
        minHeight: '504px',
      },
      '& .hero-background': {
        backgroundColor: palette.background.brandLight,
        '@media screen and (max-width: 600px)': {
          order: 1,
          marginTop: 0,
          objectFit: 'cover !important',
          objectPosition: 'center center !important',
          backgroundPosition: 'center center !important',
          height: '314px',
        },
        /* Tablet, laptop, desktop: full-bleed cover (overrides MFE contain + object-position: right) */
        '@media(min-width: 600px)': {
          position: 'absolute !important',
          top: 0,
          left: 0,
          width: '100% !important',
          height: '100% !important',
          maxWidth: 'none !important',
          objectFit: 'cover !important',
          objectPosition: 'center center',
          zIndex: 0,
        },
      },
      '& .hero-section': {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2,
        maxHeight: 'none',
        width: '100% !important',
        maxWidth: 'none !important',
        margin: '0 auto',
        boxShadow: 'none',
        /* Override MFE lg/md bottom padding so we can place content in the lower gradient */
        '@media(min-width: 600px)': {
          paddingBottom: '0 !important',
        },
        '@media(max-width: 600px)': {
          order: 2,
          marginTop: '-88px',
          zIndex: 2,
          paddingTop: '0 !important',
          paddingBottom: '50px !important',
        },
        '& .section-alternate__content > .MuiGrid-container': {
          justifyContent: 'center !important',
        },
        '& .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 600px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            minHeight: '0 !important',
            height: 'auto !important',
            alignItems: 'center !important',
          },
        },
        '& .section-alternate__content': {
          backgroundColor: 'transparent',
          width: '100% !important',
          maxWidth: '100% !important',
          '@media(min-width: 600px)': {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: '56px',
            top: 'auto',
            height: 'auto !important',
            minHeight: '0 !important',
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
          },
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
            '@media(min-width: 600px)': {
              bottom: '48px',
              paddingTop: '0 !important',
              paddingBottom: '0 !important',
            },
            '@media(max-width: 600px)': {
              position: 'static',
              padding: '0px 16px !important',
            },
          },
        },
        '& .section-header': {
          textAlign: 'center',
          justifyContent: 'center',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '0 !important',
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
            color: `${palette.text.highlight} !important`,
          },
          '& .section-header__title-wrapper': {
            marginLeft: 'auto',
            marginRight: 'auto',
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'center !important',
          },
          '& .section-header__subtitle-wrapper': {
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'center',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
            flexWrap: 'nowrap',
          },
          '& .section-header__cta-item-wrapper': {
            display: 'flex !important',
            flexDirection: 'row !important',
            flexWrap: 'nowrap !important',
            justifyContent: 'center',
            alignItems: 'center',
            columnGap: '24px',
            rowGap: 0,
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            '& .MuiButton-root': {
              borderRadius: '9999px !important',
              fontSize: '16px !important',
              lineHeight: '20px !important',
              fontWeight: '400 !important',
              letterSpacing: '-0.32px !important',
              textTransform: 'none !important',
              boxShadow: 'none !important',
              minWidth: 0,
              whiteSpace: 'nowrap',
            },
            '& .hero-link-button': {
              backgroundColor: `${palette.background.main} !important`,
              border: `1px solid ${palette.text.brandAction} !important`,
              color: `${palette.text.brandAction} !important`,
              padding: '13px 20px !important',
            },
            '& .login-button': {
              backgroundColor: 'transparent !important',
              border: `1px solid ${palette.background.border} !important`,
              color: `${palette.text.highlight} !important`,
              padding: '13px 32px !important',
            },
            /* Keep GET STARTED + LOG IN on one row on mobile */
            '@media(max-width: 599px)': {
              columnGap: '24px',
            },
          },
        },
      },
      '& .home-hero-title': {
        color: `${palette.text.highlight} !important`,
        fontSize: '64px !important',
        fontFamily: 'Montserrat-Medium',
        fontWeight: '600 !important',
        maxWidth: 960,
        marginLeft: 'auto',
        marginRight: 'auto',
        lineHeight: '72px !important',
        letterSpacing: '-3.84px !important',
        textAlign: 'center !important',
        '@media(max-width: 1024px) and (min-width: 600px)': {
          fontSize: '56px !important',
          lineHeight: '64px !important',
          letterSpacing: '-3.36px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-2.4px !important',
          textAlign: 'center !important',
        },
      },
      '& .home-hero-subtitle': {
        color: `${palette.text.highlight} !important`,
        maxWidth: 550,
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Figtree-Regular',
        fontWeight: 400,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        textAlign: 'center !important',
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Figtree-Regular',
          maxWidth: 550,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.fill,
      backgroundColor: palette.background.fill,
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        top: '-1px',
        height: '38px',
        backgroundImage: 'url("/images/home-images/wave-pricing-bottom.svg")',
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'center top',
        backgroundSize: '783px 38px',
        pointerEvents: 'none',
        zIndex: 1,
      },
      '& .definition-variant-2': {
        paddingInline: '56px !important',
        paddingBlock: '96px !important',
        '@media(max-width: 600px)': {
          paddingInline: '24px !important',
          paddingBlock: '56px !important',
        },
        '@media(min-width: 600px) and (max-width: 900px)': {
          padding: '20px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        padding: ' 0px 20px !important',
      },
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '0px 16px',

        '@media (min-width: 600px)': {
          padding: '0px 16px',
        },
        '@media (min-width: 900px) and (max-width: 1200px)': {
          padding: '0px 0px 0px',
        },
        '@media (min-width: 1200px)': {
          padding: '0px 48px 0px',
        },

      },
      '& .definition-benefits-grid': {
        display: 'flex !important',
        flexWrap: 'wrap',
        gap: '32px',
        justifyContent: 'flex-start',
        '@media(max-width: 900px)': {
          gap: '40px',
        },
      },
      '& .definition-service-tile': {
        flexBasis: 'calc((100% - 64px) / 3) !important',
        maxWidth: 'calc((100% - 64px) / 3) !important',
        border: 'none !important',
        padding: '0 !important',
        '& .definition-service-innertile': {
          justifyContent: 'left !important',
        },
        '@media(max-width: 900px)': {
          flexBasis: '100% !important',
          maxWidth: '100% !important',
          paddingBottom: '32px !important',
          borderBottom: `1px solid ${palette.background.border} !important`,
          '&:last-child': {
            paddingBottom: '0 !important',
            borderBottom: 'none !important',
          },
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        color: `${palette.text.textPrimary} !important`,
        fontWeight: '600 !important',
        fontFamily: 'Montserrat-Medium !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.96px !important',
        textAlign: 'left !important',
        paddingBottom: '8px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.96px !important',
        },
      },

      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '28px !important',
        '& img, & .image': {
          width: '56px !important',
          height: '56px !important',
          display: 'block !important',
        },
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: `${palette.text.planCardSecondary} !important`,
        textAlign: 'left !important',
        letterSpacing: '-0.32px !important',
        '@media(max-width: 1024px)': {
          fontSize: '15px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.3px !important',
        },
      },
      '& .section-header__title': {
        color: `${palette.text.textPrimary} !important`,
        fontWeight: '600 !important',
        whiteSpace: 'pre-line',
        fontFamily: 'Montserrat-Medium !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.92px !important',
        paddingBottom: '48px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          fontSize: '40px !important',
          lineHeight: '48px !important',
          letterSpacing: '-1.6px !important',
          textAlign: 'left !important',
          paddingBottom: '48px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-1.6px !important',
          textAlign: 'left !important',
          paddingBottom: '40px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      /* Tablet: remove outer gutter so plan strip can go edge-to-edge */
      '@media screen and (min-width: 600px) and (max-width: 1024px)': {
        padding: '0 !important',
      },
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundRepeat: 'no-repeat',
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':{
        color: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        fontWeight: '600 !important',
        fontFamily: 'Montserrat-Medium !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-2.8px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 1024px) and (min-width: 600px)': {
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-2.4px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-2px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Figtree-Regular !important',
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        color: `${palette.text.highlight} !important`,
        '@media screen and (min-width: 600px) and (max-width: 1024px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.72px !important',
        },
        '@media screen and (max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .section-header__overline-wrapper': {
        color: `${palette.text.onDarkTertiary} !important`,
      },
      '& .subscription-tabs': {
        minHeight: '48px !important',
        '& .MuiTabs-flexContainer': {
          width: 'fit-content',
          minWidth: '280px',
          maxWidth: '100%',
          height: '48px',
          borderRadius: '9999px !important',
          backgroundColor: `${palette.background.main} !important`,
          boxShadow: `0px 1px 10px -1px ${palette.shadowXs}`,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
        '& .MuiTabs-indicator': {
          display: 'none !important',
        },
        '& .MuiTab-root': {
          width: 'auto',
          minWidth: '140px',
          minHeight: '48px',
          height: '48px',
          padding: '14px 12px !important',
          border: 'none !important',
          whiteSpace: 'nowrap',
          borderRadius: '9999px !important',
          backgroundColor: 'transparent !important',
          color: `${palette.text.brandAction} !important`,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          fontWeight: '400 !important',
          letterSpacing: '-0.32px !important',
          textTransform: 'none !important',
          opacity: 1,
        },
        '& .MuiTab-root.Mui-selected': {
          backgroundColor: `${palette.text.brandAction} !important`,
          color: `${palette.text.highlight} !important`,
          border: `2px solid ${palette.text.highlight} !important`,
          boxSizing: 'border-box',
        },
        '@media(max-width: 600px)': {
          minHeight: '40px !important',
          '& .MuiTabs-flexContainer': {
            width: 'fit-content',
            minWidth: '248px',
            height: '48px',
          },
          '& .MuiTab-root': {
            width: 'auto',
            minWidth: '124px',
            minHeight: '40px',
            height: '48px',
            padding: '6px 16px !important',
            flex: '1 1 auto',
            whiteSpace: 'normal',
          },
          '& .subscription-tab-label': {
            lineHeight: '1.15 !important',
            '@media(max-width: 360px)': {
              fontSize: '13px !important',
            },
            '@media(min-width: 361px) and (max-width: 480px)': {
              fontSize: '15px !important',
            },
          },
        },
      },
      '& .addonsWrapper': {
        padding: '50px 80px !important',
        background: `${palette.background.main} !important`,
        '& .section-header': {
          textAlign: 'center',
          justifyContent: 'center',
          marginBottom: '32px',
        },
        '& .addons-title': {
          color: `${palette.text.primary} !important`,
          fontFamily: 'Montserrat-Medium !important',
          fontWeight: 500,
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.68px !important',
        },
        '& .addonsSubtitleVariant2': {
          color: `${palette.text.secondary} !important`,
          fontFamily: 'Figtree-Regular !important',
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
        '& .MuiCard-root': {
          minHeight: 'unset',
          borderRadius: '8px',
          border: `1px solid ${palette.background.border}`,
          boxShadow: 'none',
        },
        '& .addon-Price': {
          fontFamily: 'Montserrat-Medium !important',
          fontWeight: 500,
          fontSize: '32px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
        },
        '@media(max-width: 900px)': {
          padding: '40px 20px !important',
          '& .addons-title': {
            fontSize: '40px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .carousel-single-item': {
          alignItems: 'stretch !important',
        },
        '& .subscription-plan-card-item': {
          display: 'flex !important',
          flexDirection: 'column !important',
          alignItems: 'stretch !important',
        },
        '& .plan-carousel-item': {
          display: 'flex !important',
          flexDirection: 'column !important',
          flex: '1 1 auto !important',
          height: '100% !important',
          width: '100% !important',
          padding: '0 !important',
        },
        /* 1025 not 1024: at exactly 1024 the carousel shows one full-width card
           (tablet), which must not pick up the desktop 40px gutter. */
        '@media(min-width: 1025px)': {
          '& .plan-carousel-item': {
            padding: '0 20px !important',
          },
        },
        /* Mobile uses the grid structure (one carousel slide holding a wrapping
           .carousel-single-item), so these grid items are live here: 20px gives
           the 40px stack gap, 4px + the wrapper's 16px gives Figma's 24px gutter. */
        '@media(max-width: 600px)': {
          '& .subscription-plan-card-item': {
            padding: '20px 4px !important',
          },
        },
        /* At 1024 and below, stack the plans one per row instead of sliding.
           The MFE gives each plan its own carousel slide, so the track is made to
           wrap and each slide stretched to full width.

           Anchored on classes the MFE owns — .carousel-container (passed as
           react-multi-carousel's containerClass) and .plan-carousel-item (the
           MFE's own wrapper inside each slide) — rather than the library's
           internal .react-multi-carousel-* names. :has() picks the plan track
           and slides without naming them, and distinguishes them from the dot
           list, which is the sibling <ul> holding no plan items.

           !important is required throughout: the library writes the track
           transform and slide width as inline styles. */
        '@media(min-width: 601px) and (max-width: 1024px)': {
          '& .carousel-container': {
            overflow: 'visible !important',
          },
          '& .carousel-container ul:has(.plan-carousel-item)': {
            flexWrap: 'wrap !important',
            transform: 'none !important',
            width: '100% !important',
            position: 'static !important',
          },
          '& .carousel-container li:has(.plan-carousel-item)': {
            width: '100% !important',
            flex: '0 0 100% !important',
            /* Non-active slides get no height from the carousel; the existing
               height:100% chain then resolves to 0 in a wrapped row. */
            height: 'auto !important',
            marginBottom: '40px',
            '&:last-child': {
              marginBottom: 0,
            },
          },
          '& .plan-carousel-item, & .planCard, & .planCard .customCardContent, & .planCard .fullHeight': {
            height: 'auto !important',
          },
          /* Paging dots are meaningless once every plan is visible. The dot list
             is the one <ul> in the container with no plan items in it. */
          '& .carousel-container ul:not(:has(.plan-carousel-item))': {
            display: 'none !important',
          },
        },
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '12px !important',
          border: 'none !important',
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          height: '100%',
          '& .MuiCardContent-root, & .customCardContent': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            height: '100%',
            padding: '32px 24px !important',
          },
          '& .fullHeight': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            height: '100%',
            minHeight: 0,
            width: '100%',
          },
          '& .planCardDescription, & .customBenefitsContainer': {
            flex: '0 0 auto',
          },
          '& .plan-card-disclaimer-row': {
            marginTop: 'auto',
            width: '100%',
            flex: '0 0 auto',
          },
          /* Disable card hover; keep Get Started button hover below */
          '&:hover': {
            background: `${palette.text.highlight} !important`,
            backgroundColor: `${palette.text.highlight} !important`,
            color: `${palette.text.primary} !important`,
            boxShadow: 'none !important',
            transform: 'none !important',
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: `${palette.text.brandAction} !important`,
            color: `${palette.text.highlight} !important`,
            border: `1px solid ${palette.text.brandAction} !important`,
            '&:hover': {
              backgroundColor: palette.text.brandAction,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .MuiButton-outlinedPrimary': {
            backgroundColor: `${palette.background.main} !important`,
            borderColor: `${palette.text.brandAction} !important`,
            color: `${palette.text.brandAction} !important`,
          },
          '& .MuiButton-outlinedPrimary:hover, & .customGetStarted:hover, & .plan-card-v5-get-started:hover': {
            backgroundColor: `${palette.text.brandAction} !important`,
            border: `1px solid ${palette.text.brandAction} !important`,
            borderColor: `${palette.text.brandAction} !important`,
            color: `${palette.text.highlight} !important`,
            transition: 'none !important',
          },
          '& .customcardTitle': {
            fontWeight: '600 !important',
            fontFamily: 'Montserrat-Medium !important',
            fontSize: '24px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.96px !important',
            color: `${palette.text.textPrimary} !important`,
            '& .MuiSvgIcon-root': {
              color: `${palette.text.iconNeutral} !important`,
            },
          },
          '& .customSubscriberName': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .price-frequency, & .display-frequency': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            marginLeft: '0 !important',
            color: `${palette.text.planCardSecondary} !important`,
          },

          '& .plan-card-v5-pricing-row .price-frequency': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            marginLeft: '0 !important',
            paddingBottom: '2px !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .plan-card-v5-pricing-row .customSubscriberName': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .cptCodes': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            color: `${palette.text.textPrimary} !important`,
          },
          '& .customBenefitsContainer .bold': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
            fontWeight: '600 !important',
            letterSpacing: '-0.32px !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .customButtonWrapper': {
            margin: '0 12px 8px !important',
            width: 'calc(100% - 24px) !important',
            '& > .MuiGrid-item': {
              maxWidth: '100% !important',
              flexBasis: '100% !important',
              padding: '0 !important',
            },
          },
          '& .customGetStarted, & .plan-card-v5-get-started': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
            fontWeight: '400 !important',
            textTransform: 'none !important',
            letterSpacing: '-0.32px !important',
            padding: '13px 20px !important',
            width: '100% !important',
            borderRadius: '9999px !important',
          },
          '& .plan-card-v5-pill-primary': {
            backgroundColor: `${palette.background.brandLight} !important`,
            color: `${palette.text.highlight} !important`,
          },
          '& .plan-card-v5-pill-secondary': {
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.text.primary} !important`,
          },
          '& .price-value': {
            fontWeight: '600 !important',
            fontSize: '36px !important',
            fontFamily: 'Montserrat-Medium !important',
            lineHeight: '40px !important',
            letterSpacing: '-2.16px !important',
            color: `${palette.text.textPrimary} !important`,
            '@media screen and (max-width: 600px)': {
              fontSize: '32px !important',
              lineHeight: '36px !important',
              letterSpacing: '-1.92px !important',
            },
          },
          '& .customUpfrontWrapper': {
            color: palette.text.alternate,
            fontWeight: 400,
            fontSize: '12px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.32px !important',
            fontStyle: 'italic',
          },
          '& .disclaimerContainer': {
            color: palette.text.alternate,
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
            },
            '& .disclaimerText': {
              fontSize: '13px !important',
              lineHeight: '16px !important',
              letterSpacing: '-0.39px !important',
              fontStyle: 'italic',
              textAlign: 'left !important',
              color: `${palette.text.planCardSecondary} !important`,
            },
            '& .bold': {
              fontSize: '12px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.32px !important',
              textAlign: 'justify !important',
              fontWeight: 400,
              fontStyle: 'italic',
              fontFamily: 'Figtree-Regular !important',
              color: `${palette.text.alternate} !important`,
            },
            '& .MuiTypography-body2': {
              fontSize: '12px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.32px !important',
              textAlign: 'justify !important',
              color: palette.text.alternate,
            },
            '& > .MuiGrid-item:not([class*="customUpfrontWrapper"]) > .MuiTypography-body1.bold':
              {
                fontSize: '12px !important',
                lineHeight: '18px !important',
                letterSpacing: '-0.32px !important',
                textAlign: 'justify !important',
                fontStyle: 'normal',
                fontWeight: 400,
                fontFamily: 'Figtree-Regular !important',
                color: `${palette.text.alternate} !important`,
              },
          },
          /**
           * Tablet (600–1279px, full-width single card): show Primary Member
           * and Dependent Member price blocks side by side, sized to content
           * and sitting close together.
           */
          '@media screen and (min-width: 600px) and (max-width: 1279px)': {
            '& .price-item': {
              flex: '0 0 auto !important',
              width: 'auto !important',
              maxWidth: 'none !important',
              marginRight: '40px !important',
              boxSizing: 'border-box',
            },
          },
          /**
           * Mobile (<600px): keep the two price blocks side by side, but split
           * the row 50/50 so both fit in the narrow card.
           */
          '@media screen and (max-width: 599px)': {
            '& .price-item': {
              flex: '0 0 50% !important',
              maxWidth: '50% !important',
              marginRight: '0 !important',
              boxSizing: 'border-box',
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: `${palette.text.highlight} !important`,
          },
        },
        /* On dark pricing background only — PlanCard also uses .bold for white-card section labels */
        '& .bold': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.onDarkEmphasis} !important`,
          fontFamily: 'Montserrat-Medium !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .planCard .bold': {
          color: `${palette.text.primary} !important`,
        },
        '& .summary-text': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.8px !important',
          fontFamily: 'Figtree-Regular !important',
          color: `${palette.text.highlight} !important`,
          '@media screen and (min-width: 600px) and (max-width: 1024px)': {
            fontSize: '18px !important',
            lineHeight: '28px !important',
          },
          '@media screen and (max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
          },
        },
        '& .summary-subtext': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.onDarkSecondary} !important`,
          '@media screen and (min-width: 600px) and (max-width: 1024px)': {
            fontSize: '18px !important',
            lineHeight: '28px !important',
          },
          '@media screen and (max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
          },
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        /**
         * Tablet (600–1279px): stack plan cards one by one at full width;
         * 3-per-row grid applies at lg (1280px+) only.
         */
        '@media screen and (min-width: 600px) and (max-width: 1279px)': {
          maxWidth: '100%',
          width: '100%',
          boxSizing: 'border-box',
          padding: '50px !important',
          '& > .section-alternate__content.subscription-section': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            maxWidth: '100%',
            boxSizing: 'border-box',
          },
          '& .subscription-section > .section-header': {
            paddingLeft: '16px',
            paddingRight: '16px',
            boxSizing: 'border-box',
          },
          '& .subscription-tabs': {
            marginLeft: '16px',
            marginRight: '16px',
            boxSizing: 'border-box',
          },
          '& .summary-text, & .summary-subtext': {
            paddingLeft: '16px',
            paddingRight: '16px',
            boxSizing: 'border-box',
          },
          '& .carousel-container': {
            maxWidth: '100% !important',
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: 0,
            paddingRight: 0,
            boxSizing: 'border-box',
          },
          '& .carousel-single-item': {
            width: '100% !important',
            maxWidth: '100% !important',
            marginLeft: '0 !important',
            marginRight: '0 !important',
            display: 'flex !important',
            flexDirection: 'column !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            boxSizing: 'border-box',
          },
          '& .carousel-single-item > .MuiGrid-item, & .subscription-plan-card-item': {
            maxWidth: '100% !important',
            flexBasis: 'auto !important',
            flexGrow: '0 !important',
            width: '100% !important',
            boxSizing: 'border-box',
          },
          '& .plan-carousel-item': {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            boxSizing: 'border-box',
          },
          '& .planCard': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.main,
      backgroundColor: palette.background.main,
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '-1px',
        height: '38px',
        backgroundImage: 'url("/images/home-images/wave-brand.svg")',
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'center bottom',
        backgroundSize: '783px 38px',
        transform: 'scaleY(-1)',
        pointerEvents: 'none',
        zIndex: 1,
      },
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '96px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
          flexBasis: '46.875% !important',
          maxWidth: '46.875% !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
          borderRadius: '24px',
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          color: `${palette.text.textPrimary} !important`,
          whiteSpace: 'pre-line',
          fontFamily: 'Montserrat-Medium !important',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.92px !important',
          fontWeight: '600 !important',
          '@media(min-width: 600px) and (max-width: 1024px)': {
            fontSize: '40px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '40px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle-wrapper': {
          paddingTop: '4px !important',
        },
        '& .section-header__subtitle': {
          fontWeight: '600 !important',
          color: `${palette.text.planCardSecondary} !important`,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.4px !important',
          '@media(min-width: 600px) and (max-width: 1024px)': {
            fontSize: '18px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.8px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-grid': {
        '@media(min-width: 1024px)': {
          justifyContent: 'space-between !important',
        },
      },
      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(min-width: 1024px)': {
          flexBasis: '43.75% !important',
          maxWidth: '43.75% !important',
        },
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: `${palette.text.iconBrandAlt} !important`,
        color: palette.text.highlight,
        fontSize: 14,
        lineHeight: '20px !important',
        fontWeight: '600 !important',
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '& .step-title': {
          color: `${palette.text.textPrimary} !important`,
          fontSize: 20,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: '600 !important',
          fontFamily: 'Montserrat-Medium !important',
          paddingBottom: '8px !important',
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.44px !important',
          },
        },
        '& .step-content': {
          fontSize: '16px !important',
          color: `${palette.text.planCardSecondary} !important`,
          lineHeight: '22px !important',
          letterSpacing: '-0.32px !important',
          fontWeight: 400,
          '@media(max-width: 1024px)': {
            fontSize: '15px !important',
            lineHeight: '22px !important',
          },
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 32,
        marginBottom: 32,
        borderBottom: `1px solid ${palette.background.border}`,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `${palette.text.brandAction}`,
        backgroundSize: 'cover',
      },
      /* Header row Back to Home (outlined) on light content area */
      '& .customBackToHomeButton': {
        borderRadius: '30px !important',
        background: 'transparent !important',
        backgroundColor: 'transparent !important',
        color: `${palette.text.primary} !important`,
        borderColor: `${palette.primary.main} !important`,
        boxShadow: 'none',
        '&:hover': {
          background: 'transparent !important',
          backgroundColor: 'transparent !important',
          borderColor: `${palette.primary.main} !important`,
          color: `${palette.text.primary} !important`,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 400,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.brandAccent} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.background.brandLight,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.background.brandLight,
          color: palette.text.highlight,
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
          '@media(max-width: 600px)': {
            paddingInline: '40px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 206,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingInline: '90px !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.text.brandAction} !important`,
      },
      '& .section-header__title': {
        color: palette.text.highlight,
        fontWeight: '600 !important',
        fontFamily: 'Montserrat-Medium !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-2.16px !important',
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '-1.92px !important',
        },
      },
      '& .section-header': {
        marginBottom: '-8px !important',
      },
      '& .section-header__subtitle-wrapper': {
        paddingTop: '4px !important',
      },
      '& .section-header__subtitle': {
        color: palette.text.highlight,
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.72px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .MuiButton-root': {
          borderRadius: '9999px !important',
          fontSize: '16px !important',
          lineHeight: '20px !important',
          fontWeight: '400 !important',
          letterSpacing: '-0.32px !important',
          textTransform: 'none !important',
          padding: '14px 16px !important',
        },
        '& .primary-static-button': {
          backgroundColor: `${palette.secondary.main} !important`,
          color: `${palette.text.textPrimary} !important`,
          '&:hover': {
            backgroundColor: `${palette.secondary.main} !important`,
            color: `${palette.text.textPrimary} !important`,
            filter: 'brightness(0.92)',
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'right !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
      '& .card-wrapper .MuiButton-containedPrimary': {
        backgroundColor: `${palette.text.brandAction} !important`,
        color: `${palette.text.highlight} !important`,
        '&:hover': {
          backgroundColor: `${palette.text.brandAction} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .section-header__title': {
        color: `${palette.text.brand} !important`,
      },
      '& .plans-wrapper': {
        '& .plan-cards-grid > .plan-card-grid-item': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        },
        '& .plan-card-grid-cell': {
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          height: '100%',
          width: '100%',
        },
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          width: '100%',
          height: '100%',
          overflow: 'visible',
          /* Disable card hover; keep Get Started button hover below */
          '&:hover': {
            background: `${palette.text.highlight} !important`,
            backgroundColor: `${palette.text.highlight} !important`,
            color: `${palette.text.primary} !important`,
            boxShadow: 'none !important',
            transform: 'none !important',
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'Montserrat-Medium !important',
            fontSize: '24px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.64px !important',
            color: `${palette.text.brand} !important`,
          },
          '& .customSubscriberName': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .price-frequency, & .display-frequency': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            marginLeft: '0 !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .plan-card-v5-pricing-row .price-frequency': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            marginLeft: '0 !important',
            paddingBottom: '2px !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .plan-card-v5-pricing-row .customSubscriberName': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            fontWeight: '400 !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .cptCodes': {
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            color: `${palette.text.textPrimary} !important`,
          },
          '& .customBenefitsContainer .bold': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
            color: `${palette.text.planCardSecondary} !important`,
          },
          '& .price-value': {
            fontWeight: 500,
            fontSize: '36px !important',
            fontFamily: 'Montserrat-Medium !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            '@media screen and (max-width: 600px)': {
              fontSize: '32px !important',
              lineHeight: '36px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .MuiCardContent-root': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            height: '100%',
            overflow: 'visible',
          },
          '& .fullHeight': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            height: '100%',
            minHeight: 0,
            width: '100%',
          },
          '& .planCardDescription': {
            flex: '0 0 auto',
            height: 'auto',
            width: '100%',
            overflow: 'visible',
          },
          '& .plan-card-disclaimer-row': {
            marginTop: 'auto',
            width: '100%',
            flex: '0 0 auto',
          },
          '& .disclaimerContainer': {
            width: '100% !important',
            color: palette.text.alternate,
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
              fontSize: '12px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.32px !important',
              color: palette.text.alternate,
            },
            '& .disclaimerText': {
              fontSize: '12px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.32px !important',
              textAlign: 'justify !important',
              color: palette.text.alternate,
            },
            '& .bold': {
              fontSize: '12px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.32px !important',
              textAlign: 'justify !important',
              fontWeight: 400,
              fontStyle: 'italic',
              fontFamily: 'Figtree-Regular !important',
              color: `${palette.text.alternate} !important`,
            },
            '& .MuiTypography-body2': {
              fontSize: '12px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.32px !important',
              textAlign: 'justify !important',
              color: palette.text.alternate,
            },
            '& > .MuiGrid-item:not([class*="customUpfrontWrapper"]) > .MuiTypography-body1.bold':
              {
                fontSize: '12px !important',
                lineHeight: '18px !important',
                letterSpacing: '-0.32px !important',
                textAlign: 'justify !important',
                fontStyle: 'normal',
                fontWeight: 400,
                fontFamily: 'Figtree-Regular !important',
                color: `${palette.text.alternate} !important`,
              },
          },
          '& .customButtonWrapper': {
            width: '100% !important',
            marginLeft: '0 !important',
            '& > .MuiGrid-item': {
              flexBasis: '100% !important',
              maxWidth: '100% !important',
            },
          },
          '& .customGetStarted, & .plan-card-v5-get-started': {
            width: '100% !important',
            fontSize: '16px !important',
            lineHeight: '20px !important',
            fontWeight: '400 !important',
            textTransform: 'none !important',
            letterSpacing: '-0.32px !important',
            padding: '13px !important',
            backgroundColor: 'transparent !important',
            borderColor: `${palette.background.brandLight} !important`,
            color: `${palette.background.brandLight} !important`,
            '&:hover': {
              backgroundColor: `${palette.background.brandLight} !important`,
              border: `1px solid ${palette.background.brandLight} !important`,
              borderColor: `${palette.background.brandLight} !important`,
              color: `${palette.text.highlight} !important`,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .MuiTab-root': {
        textTransform: 'none !important',
      },
      '& .faq-link': {
        fontSize: '15px !important',
        textTransform: 'none !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 400,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'Montserrat-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'Figtree-Regular !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'Montserrat-Medium !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .section-header__title': {
        color: `${palette.text.primary} !important`,
      },
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'Montserrat-Medium',
        fontWeight: 400,
      },
      '& .MuiButton-containedPrimary:not(.Mui-disabled), & .MuiButton-containedSecondary:not(.Mui-disabled)': {
        background: `${palette.background.brandLight} !important`,
        backgroundColor: `${palette.background.brandLight} !important`,
        color: `${palette.text.highlight} !important`,
        '&:hover': {
          background: `${palette.background.brandLight} !important`,
          backgroundColor: `${palette.background.brandLight} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
      '& .cancel-button': {
        background: `${palette.background.dark} !important`,
        backgroundColor: `${palette.background.dark} !important`,
        color: `${palette.text.highlight} !important`,
        boxShadow: 'none',
        '&:hover': {
          background: `${palette.background.dark} !important`,
          backgroundColor: `${palette.background.dark} !important`,
          color: `${palette.text.highlight} !important`,
          filter: 'brightness(0.92)',
        },
      },
      '& .cancel-button.MuiButton-containedSecondary': {
        '&:hover': {
          backgroundColor: `${palette.background.dark} !important`,
        },
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.primary.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.brandLight,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.brandLight ,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 400,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 400,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
};
